var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconGithub(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.667c-4.602 0-8.333 3.688-8.333 8.239 0 3.64 2.387 6.728 5.699 7.818.416.076.569-.179.569-.396 0-.197-.008-.846-.011-1.534-2.319.498-2.808-.972-2.808-.972-.379-.953-.925-1.206-.925-1.206-.756-.511.057-.5.057-.5.837.057 1.277.848 1.277.848.743 1.26 1.95.896 2.425.685.075-.532.291-.896.53-1.102-1.852-.208-3.797-.914-3.797-4.071 0-.9.325-1.635.858-2.212-.086-.208-.372-1.046.081-2.18 0 0 .7-.222 2.292.844A8.073 8.073 0 0110 5.651a8.094 8.094 0 012.088.277c1.59-1.066 2.29-.844 2.29-.844.453 1.134.167 1.972.08 2.18a3.16 3.16 0 01.858 2.212c0 3.164-1.95 3.86-3.805 4.065.3.255.566.757.566 1.526 0 1.102-.01 1.99-.01 2.26 0 .22.15.477.572.396 3.31-1.09 5.694-4.178 5.694-7.817 0-4.55-3.73-8.24-8.333-8.24",
    fill: "#036fe2",
    fillRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "e6c52980c4286db0b26d3939ab0f0e1e.svg";
export { SvgIconGithub as ReactComponent };